// extracted by mini-css-extract-plugin
export default {"detailDetailsSidePanelRow":"DealerDetailsSidePanelRow__detailDetailsSidePanelRow-tttO","iconTextWrapper":"DealerDetailsSidePanelRow__iconTextWrapper-dVQD"};